const Error = ({msg}) => {

    return (
        <div className="d-flex flex-column align-items-center justify-content-center">
            <i className="far fa-times-circle text-danger" style={{fontSize:58}}></i>
            <span className="mt-2" style={{fontSize:20}}>
            {msg}
            </span>
        </div>
    );
}

export default Error;

